/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 14:08:11
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-11 14:47:10
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import styles from './varietyManagement.module.css'
import { printBody } from '../../../models/approvalFormModalPrint'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  getDetailAsync,
  getFirstsellrecordBaseSubmitAsync,
} from './varietyManagementSlice'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { getUserList, selectUserPage } from '../../user/userSlice'
const { Option } = Select

export const ApprovalFormModal = (props: {
  editTenantId?:any
  isEdit?: any
  fsrid?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const [detail, setDetail] = useState<any>()

  const [userList, setUserList] = useState<any>()

  const [printFlag, setPrintFlag] = useState(false)

  const [buttonLoading, setButtonLoading] = useState(false)

  useEffect(() => {
    if (props.isModalVisible) {
      dispatch(getUserList({ current: 1, size: 1000, state: 1 }))
        .then(unwrapResult)
        .then((res: any) => {
          setUserList(res?.items)
        })
    }
  }, [props.isModalVisible])

  const getDetail = (flag?:any) => {
    dispatch(getDetailAsync({fsrid:props?.fsrid,tenantId:props?.editTenantId}))
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)
        form.setFieldsValue({
          ...v,
          stockPrice: v?.stockPrice > 0 ? v?.stockPrice : '',
          deadline: v?.deadline ? moment(v?.deadline) : null,
          firstTime: v?.firstTime ? moment(v?.firstTime) : null,
          createUser: v?.createUser?.toString(),
        })
        // 打印
        if (printFlag || flag) {
          const dataMain = {
            ...v,
            createUserName: userList?.find(
              (n: any) => n?.id == detail?.createUser
            )?.name,
          }
          const content = printBody(dataMain)
          const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
          page.document.write(content) // 写入打印页面的内容
          page.print() // 打印
          page?.close()
          window.close()
          props.onCancel()
          setPrintFlag(false)
        }
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      setPrintFlag(false)
      getDetail()
    } else {
      form.resetFields()
      setPrintFlag(false)
    }
  }, [props.isModalVisible, props?.fsrid])

  return (
    <Modal
      className={styles.ApprovalFormModal}
      width={1000}
      title=''
      maskClosable={false}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <div className={styles.form}>
        <Form
          autoComplete='off'
          form={form}
          onFinish={(values) => {
            setButtonLoading(true)
            const params = {
              contactName: values?.contactName,
              contactPhone: values?.contactPhone,
              createUser: values?.createUser,
              deadline: values?.deadline
                ? moment(values?.deadline).format(DateTimeFormatSimple)
                : undefined,
              id: detail?.id,
              indication: values?.indication,
              qualityCondition: values?.qualityCondition,
              qualityStandard: values?.qualityStandard,
              // recordDate: values?.recordDate,
              remark: values?.remark,
            }
            dispatch(
              getFirstsellrecordBaseSubmitAsync({
                ...params,
              })
            )
              .then(unwrapResult)
              .then(() => {
                if (printFlag) {
                  getDetail()
                } else {
                  notification.success({
                    message: '操作成功',
                  })
                  props?.onOk()
                }
              })
              .finally(() => {
                setButtonLoading(false)
              })
          }}
        >
          <div className={styles.approvalFormTitle}>首营品种审批表</div>
          <Row
            style={{
              margin: '0 24px',
              fontSize: '14px',
            }}
          >
            <Col
              span={12}
              className={styles.inputStyle}
              style={{ display: 'flex', justifyContent: 'flex-start' }}
            >
              <Form.Item name='' label='编号'>
                <Input
                  disabled
                  style={{
                    width: '90px',
                  }}
                ></Input>
              </Form.Item>
            </Col>
            <Col
              span={12}
              className={styles.inputStyle}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Form.Item name='' label='申报日期'>
                <Input disabled style={{ width: '50px' }}></Input>
                <span style={{ padding: '0 4px' }}>年</span>
                <Input disabled style={{ width: '30px' }}></Input>
                <span style={{ padding: '0 4px' }}>月</span>
                <Input disabled style={{ width: '30px' }}></Input>
                <span style={{ padding: '0 4px' }}>日</span>
              </Form.Item>
            </Col>
          </Row>
          <div
            className={styles.noBorder}
            style={{
              width: '100%',
              height: '570px',
              overflow: 'auto',
              paddingRight: '10px',
            }}
          >
            <table className={styles.table}>
              <thead style={{ height: '18px' }}>
                <tr>
                  <th style={{ width: '13%' }}>通用名</th>
                  <th className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='genericName'>
                      <Input disabled></Input>
                    </Form.Item>
                  </th>
                  <th style={{ width: '13%' }}>商品名</th>
                  <th className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='name'>
                      <Input disabled></Input>
                    </Form.Item>
                  </th>
                  <th style={{ width: '13%' }}>商品编码</th>
                  <th className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='no'>
                      <Input disabled></Input>
                    </Form.Item>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: '13%' }}>剂型</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='doseCategory'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>规格</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='spec'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>质量标准</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='qualityStandard'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>批准文号</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='approvalNumber'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>存储条件</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='putCategory'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>有效期</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='deadline'>
                      <DatePicker
                        disabled={props?.isEdit == '0' ? true : false}
                        format={DateTimeFormatSimple}
                        onChange={() => {
                          return
                        }}
                      />
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>适应症</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '87%' }}
                    colSpan={5}
                  >
                    <Form.Item name='indication'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>生产企业名称</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '54%' }}
                    colSpan={3}
                  >
                    <Form.Item name='tenantSupplierName'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>剂量单位</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='accountUnit'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>生产地址</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '87%' }}
                    colSpan={5}
                  >
                    <Form.Item name='origin'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>含税进价</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='stockPrice'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>售价</td>

                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '54%' }}
                    colSpan={3}
                  >
                    <Form.Item name='retailPrice'>
                      <Input disabled></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>供货联系人</td>
                  <td className={styles.inputNoStyle} style={{ width: '20%' }}>
                    <Form.Item name='contactName'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>电话</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '54%' }}
                    colSpan={3}
                  >
                    <Form.Item name='contactPhone'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>质量状况</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '87%' }}
                    colSpan={5}
                  >
                    <Form.Item name='qualityCondition'>
                      <Input
                        disabled={props?.isEdit == '0' ? true : false}
                      ></Input>
                    </Form.Item>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>采购意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Form.Item name='buyOpinion'>
                        <Input.TextArea rows={2} disabled></Input.TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='采购人'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                          value={
                            detail?.buyOpinionTime
                              ? moment(detail?.buyOpinionTime).format('YYYY')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.buyOpinionTime
                              ? moment(detail?.buyOpinionTime).format('MM')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.buyOpinionTime
                              ? moment(detail?.buyOpinionTime).format('DD')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>质量审核意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Form.Item name='qualityAuditOpinion'>
                        <Input.TextArea
                          rows={2}
                          disabled
                          maxLength={500}
                        ></Input.TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='审核人'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                          value={
                            detail?.qualityAuditTime
                              ? moment(detail?.qualityAuditTime).format('YYYY')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.qualityAuditTime
                              ? moment(detail?.qualityAuditTime).format('MM')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.qualityAuditTime
                              ? moment(detail?.qualityAuditTime).format('DD')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>审批意见</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputTextStyle}>
                      <Form.Item name='approvalOpinion'>
                        <Input.TextArea rows={2} disabled></Input.TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      span={24}
                      className={styles.inputStyles}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Form.Item name='' label='企业负责人'>
                        <Input
                          disabled
                          style={{ width: '50px', marginLeft: '80px' }}
                          value={
                            detail?.approvalOpinionTime
                              ? moment(detail?.approvalOpinionTime).format(
                                  'YYYY'
                                )
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>年</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.approvalOpinionTime
                              ? moment(detail?.approvalOpinionTime).format('MM')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>月</span>
                        <Input
                          disabled
                          style={{ width: '30px' }}
                          value={
                            detail?.approvalOpinionTime
                              ? moment(detail?.approvalOpinionTime).format('DD')
                              : ''
                          }
                        ></Input>
                        <span style={{ padding: '0 4px' }}>日</span>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>备注</td>
                  <td style={{ width: '87%' }} colSpan={5}>
                    <Col span={24} className={styles.inputRemarkStyle}>
                      <Form.Item name='remark'>
                        <Input.TextArea
                          rows={3}
                          disabled={props?.isEdit == '0' ? true : false}
                        ></Input.TextArea>
                      </Form.Item>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: '13%' }}>制表人</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '37%' }}
                    colSpan={2}
                  >
                    <Form.Item name='createUser'>
                      <Select
                        placeholder=''
                        disabled={props?.isEdit == '0' ? true : false}
                      >
                        {userList?.map((v: any, i: any) => {
                          return (
                            <Option value={v?.id} key={i}>
                              {v?.name}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </td>
                  <td style={{ width: '13%' }}>日期</td>
                  <td
                    className={styles.inputNoStyle}
                    style={{ width: '37%' }}
                    colSpan={2}
                  >
                    <Form.Item name=''>
                      <DatePicker
                        placeholder=''
                        disabled
                        format={DateTimeFormatSimple}
                        onChange={() => {
                          return
                        }}
                      />
                    </Form.Item>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Row
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <span
              style={{ marginRight: '10px', lineHeight: '32px', color: 'red' }}
            >
              说明:黄色背景表示可编辑，点击右侧“保存”按钮生效
            </span>
            <Button
              type='primary'
              loading={buttonLoading}
              style={{ marginRight: '10px' }}
              onClick={() => {
                setPrintFlag(true)
                if (props?.isEdit == '0') {
                  getDetail(true)
                } else {
                  form.submit()
                }
              }}
            >
              开始打印
            </Button>
            {props?.isEdit == '0' ? (
              <></>
            ) : (
              <>
                <Button
                  type='primary'
                  loading={buttonLoading}
                  onClick={() => {
                    form.submit()
                    setPrintFlag(false)
                  }}
                  ghost
                  style={{ marginRight: '10px' }}
                >
                  保存
                </Button>
                <Button
                  type='primary'
                  ghost
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    props?.onCancel()
                  }}
                >
                  取消
                </Button>
              </>
            )}
          </Row>
        </Form>
      </div>
    </Modal>
  )
}
